<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-[25px] mb-[25px]"
  >
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <img
              src="@/assets/images/users/user11.jpg"
              alt="user-image"
              class="w-[65px] h-[65px] rounded-full border-[2px] border-gray-100 dark:border-[#172036]"
            />
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <span
                class="text-md inline-block mb-px font-medium text-black dark:text-white"
              >
                Ava Turner
              </span>
              <span class="block"> Team Leader </span>
            </div>
          </div>
          <div class="flex items-center gap-[9px]">
            <button
              type="button"
              class="text-primary-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="View"
            >
              <i class="material-symbols-outlined !text-md"> visibility </i>
            </button>
            <button
              type="button"
              class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Edit"
            >
              <i class="material-symbols-outlined !text-md"> edit </i>
            </button>
            <button
              type="button"
              class="text-danger-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Delete"
            >
              <i class="material-symbols-outlined !text-md"> delete </i>
            </button>
          </div>
        </div>
        <div class="text-center mt-[15px]">
          <span
            class="inline-block font-medium bg-purple-100 dark:bg-[#15203c] text-black dark:text-white rounded-full px-[15px] py-[4.5px] mb-[15px]"
          >
            Project Management
          </span>
          <span class="block mb-[8px]"> Team Members </span>
          <div class="flex items-center justify-center">
            <img
              src="@/assets/images/users/user15.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user16.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user17.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <div
              class="rounded-full w-[40px] h-[40px] font-medium text-xs border-[2px] border-gray-100 dark:border-[#172036] bg-primary-500 text-white flex items-center justify-center -mx-[6px]"
            >
              +4
            </div>
          </div>
        </div>
        <div class="mt-[18px] mb-[20px] md:mb-[25px] lg:mb-[30px]">
          <div class="flex items-center justify-between">
            <span class="block font-medium mb-[8px]"> Progress </span>
            <span class="block font-medium mb-[8px]"> 85% </span>
          </div>
          <div
            class="flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]"
          >
            <div
              class="flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md"
              style="width: 85%"
            ></div>
          </div>
        </div>
        <a
          href="javascript:void(0);"
          class="block w-full rounded-md text-center font-medium border border-primary-500 py-[8.5px] px-[15px] text-primary-500 transition-all hover:bg-primary-500 hover:text-white"
        >
          View Details
        </a>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <img
              src="@/assets/images/users/user12.jpg"
              alt="user-image"
              class="w-[65px] h-[65px] rounded-full border-[2px] border-gray-100 dark:border-[#172036]"
            />
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <span
                class="text-md inline-block mb-px font-medium text-black dark:text-white"
              >
                Ethan Parker
              </span>
              <span class="block"> Team Leader </span>
            </div>
          </div>
          <div class="flex items-center gap-[9px]">
            <button
              type="button"
              class="text-primary-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="View"
            >
              <i class="material-symbols-outlined !text-md"> visibility </i>
            </button>
            <button
              type="button"
              class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Edit"
            >
              <i class="material-symbols-outlined !text-md"> edit </i>
            </button>
            <button
              type="button"
              class="text-danger-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Delete"
            >
              <i class="material-symbols-outlined !text-md"> delete </i>
            </button>
          </div>
        </div>
        <div class="text-center mt-[15px]">
          <span
            class="inline-block font-medium bg-secondary-100 dark:bg-[#15203c] text-black dark:text-white rounded-full px-[15px] py-[4.5px] mb-[15px]"
          >
            eCommerce Theme
          </span>
          <span class="block mb-[8px]"> Team Members </span>
          <div class="flex items-center justify-center">
            <img
              src="@/assets/images/users/user6.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user7.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user8.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
          </div>
        </div>
        <div class="mt-[18px] mb-[20px] md:mb-[25px] lg:mb-[30px]">
          <div class="flex items-center justify-between">
            <span class="block font-medium mb-[8px]"> Progress </span>
            <span class="block font-medium mb-[8px]"> 45% </span>
          </div>
          <div
            class="flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]"
          >
            <div
              class="flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md"
              style="width: 45%"
            ></div>
          </div>
        </div>
        <a
          href="javascript:void(0);"
          class="block w-full rounded-md text-center font-medium border border-primary-500 py-[8.5px] px-[15px] text-primary-500 transition-all hover:bg-primary-500 hover:text-white"
        >
          View Details
        </a>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <img
              src="@/assets/images/users/user13.jpg"
              alt="user-image"
              class="w-[65px] h-[65px] rounded-full border-[2px] border-gray-100 dark:border-[#172036]"
            />
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <span
                class="text-md inline-block mb-px font-medium text-black dark:text-white"
              >
                Isabella Lee
              </span>
              <span class="block"> Team Leader </span>
            </div>
          </div>
          <div class="flex items-center gap-[9px]">
            <button
              type="button"
              class="text-primary-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="View"
            >
              <i class="material-symbols-outlined !text-md"> visibility </i>
            </button>
            <button
              type="button"
              class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Edit"
            >
              <i class="material-symbols-outlined !text-md"> edit </i>
            </button>
            <button
              type="button"
              class="text-danger-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Delete"
            >
              <i class="material-symbols-outlined !text-md"> delete </i>
            </button>
          </div>
        </div>
        <div class="text-center mt-[15px]">
          <span
            class="inline-block font-medium bg-success-100 dark:bg-[#15203c] text-black dark:text-white rounded-full px-[15px] py-[4.5px] mb-[15px]"
          >
            Shopify Theme Dev
          </span>
          <span class="block mb-[8px]"> Team Members </span>
          <div class="flex items-center justify-center">
            <img
              src="@/assets/images/users/user10.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user11.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
          </div>
        </div>
        <div class="mt-[18px] mb-[20px] md:mb-[25px] lg:mb-[30px]">
          <div class="flex items-center justify-between">
            <span class="block font-medium mb-[8px]"> Progress </span>
            <span class="block font-medium mb-[8px]"> 70% </span>
          </div>
          <div
            class="flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]"
          >
            <div
              class="flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md"
              style="width: 70%"
            ></div>
          </div>
        </div>
        <a
          href="javascript:void(0);"
          class="block w-full rounded-md text-center font-medium border border-primary-500 py-[8.5px] px-[15px] text-primary-500 transition-all hover:bg-primary-500 hover:text-white"
        >
          View Details
        </a>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <img
              src="@/assets/images/users/user14.jpg"
              alt="user-image"
              class="w-[65px] h-[65px] rounded-full border-[2px] border-gray-100 dark:border-[#172036]"
            />
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <span
                class="text-md inline-block mb-px font-medium text-black dark:text-white"
              >
                Thompson Torres
              </span>
              <span class="block"> Team Leader </span>
            </div>
          </div>
          <div class="flex items-center gap-[9px]">
            <button
              type="button"
              class="text-primary-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="View"
            >
              <i class="material-symbols-outlined !text-md"> visibility </i>
            </button>
            <button
              type="button"
              class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Edit"
            >
              <i class="material-symbols-outlined !text-md"> edit </i>
            </button>
            <button
              type="button"
              class="text-danger-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Delete"
            >
              <i class="material-symbols-outlined !text-md"> delete </i>
            </button>
          </div>
        </div>
        <div class="text-center mt-[15px]">
          <span
            class="inline-block font-medium bg-orange-100 dark:bg-[#15203c] text-black dark:text-white rounded-full px-[15px] py-[4.5px] mb-[15px]"
          >
            Oito - HTML
          </span>
          <span class="block mb-[8px]"> Team Members </span>
          <div class="flex items-center justify-center">
            <img
              src="@/assets/images/users/user30.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user29.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user28.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
          </div>
        </div>
        <div class="mt-[18px] mb-[20px] md:mb-[25px] lg:mb-[30px]">
          <div class="flex items-center justify-between">
            <span class="block font-medium mb-[8px]"> Progress </span>
            <span class="block font-medium mb-[8px]"> 90% </span>
          </div>
          <div
            class="flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]"
          >
            <div
              class="flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md"
              style="width: 90%"
            ></div>
          </div>
        </div>
        <a
          href="javascript:void(0);"
          class="block w-full rounded-md text-center font-medium border border-primary-500 py-[8.5px] px-[15px] text-primary-500 transition-all hover:bg-primary-500 hover:text-white"
        >
          View Details
        </a>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <img
              src="@/assets/images/users/user15.jpg"
              alt="user-image"
              class="w-[65px] h-[65px] rounded-full border-[2px] border-gray-100 dark:border-[#172036]"
            />
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <span
                class="text-md inline-block mb-px font-medium text-black dark:text-white"
              >
                Lucas Lyon
              </span>
              <span class="block"> Team Leader </span>
            </div>
          </div>
          <div class="flex items-center gap-[9px]">
            <button
              type="button"
              class="text-primary-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="View"
            >
              <i class="material-symbols-outlined !text-md"> visibility </i>
            </button>
            <button
              type="button"
              class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Edit"
            >
              <i class="material-symbols-outlined !text-md"> edit </i>
            </button>
            <button
              type="button"
              class="text-danger-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Delete"
            >
              <i class="material-symbols-outlined !text-md"> delete </i>
            </button>
          </div>
        </div>
        <div class="text-center mt-[15px]">
          <span
            class="inline-block font-medium bg-primary-100 dark:bg-[#15203c] text-black dark:text-white rounded-full px-[15px] py-[4.5px] mb-[15px]"
          >
            Tanus - Template
          </span>
          <span class="block mb-[8px]"> Team Members </span>
          <div class="flex items-center justify-center">
            <img
              src="@/assets/images/users/user25.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user26.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user27.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
          </div>
        </div>
        <div class="mt-[18px] mb-[20px] md:mb-[25px] lg:mb-[30px]">
          <div class="flex items-center justify-between">
            <span class="block font-medium mb-[8px]"> Progress </span>
            <span class="block font-medium mb-[8px]"> 75% </span>
          </div>
          <div
            class="flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]"
          >
            <div
              class="flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md"
              style="width: 75%"
            ></div>
          </div>
        </div>
        <a
          href="javascript:void(0);"
          class="block w-full rounded-md text-center font-medium border border-primary-500 py-[8.5px] px-[15px] text-primary-500 transition-all hover:bg-primary-500 hover:text-white"
        >
          View Details
        </a>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <img
              src="@/assets/images/users/user16.jpg"
              alt="user-image"
              class="w-[65px] h-[65px] rounded-full border-[2px] border-gray-100 dark:border-[#172036]"
            />
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <span
                class="text-md inline-block mb-px font-medium text-black dark:text-white"
              >
                Morgan Sturges
              </span>
              <span class="block"> Team Leader </span>
            </div>
          </div>
          <div class="flex items-center gap-[9px]">
            <button
              type="button"
              class="text-primary-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="View"
            >
              <i class="material-symbols-outlined !text-md"> visibility </i>
            </button>
            <button
              type="button"
              class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Edit"
            >
              <i class="material-symbols-outlined !text-md"> edit </i>
            </button>
            <button
              type="button"
              class="text-danger-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Delete"
            >
              <i class="material-symbols-outlined !text-md"> delete </i>
            </button>
          </div>
        </div>
        <div class="text-center mt-[15px]">
          <span
            class="inline-block font-medium bg-danger-100 dark:bg-[#15203c] text-black dark:text-white rounded-full px-[15px] py-[4.5px] mb-[15px]"
          >
            Delft - TypeScript
          </span>
          <span class="block mb-[8px]"> Team Members </span>
          <div class="flex items-center justify-center">
            <img
              src="@/assets/images/users/user24.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
          </div>
        </div>
        <div class="mt-[18px] mb-[20px] md:mb-[25px] lg:mb-[30px]">
          <div class="flex items-center justify-between">
            <span class="block font-medium mb-[8px]"> Progress </span>
            <span class="block font-medium mb-[8px]"> 65% </span>
          </div>
          <div
            class="flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]"
          >
            <div
              class="flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md"
              style="width: 65%"
            ></div>
          </div>
        </div>
        <a
          href="javascript:void(0);"
          class="block w-full rounded-md text-center font-medium border border-primary-500 py-[8.5px] px-[15px] text-primary-500 transition-all hover:bg-primary-500 hover:text-white"
        >
          View Details
        </a>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <img
              src="@/assets/images/users/user17.jpg"
              alt="user-image"
              class="w-[65px] h-[65px] rounded-full border-[2px] border-gray-100 dark:border-[#172036]"
            />
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <span
                class="text-md inline-block mb-px font-medium text-black dark:text-white"
              >
                Sophia McNeel
              </span>
              <span class="block"> Team Leader </span>
            </div>
          </div>
          <div class="flex items-center gap-[9px]">
            <button
              type="button"
              class="text-primary-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="View"
            >
              <i class="material-symbols-outlined !text-md"> visibility </i>
            </button>
            <button
              type="button"
              class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Edit"
            >
              <i class="material-symbols-outlined !text-md"> edit </i>
            </button>
            <button
              type="button"
              class="text-danger-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Delete"
            >
              <i class="material-symbols-outlined !text-md"> delete </i>
            </button>
          </div>
        </div>
        <div class="text-center mt-[15px]">
          <span
            class="inline-block font-medium bg-primary-100 dark:bg-[#15203c] text-black dark:text-white rounded-full px-[15px] py-[4.5px] mb-[15px]"
          >
            Trezo - Angular
          </span>
          <span class="block mb-[8px]"> Team Members </span>
          <div class="flex items-center justify-center">
            <img
              src="@/assets/images/users/user21.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user22.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user23.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
          </div>
        </div>
        <div class="mt-[18px] mb-[20px] md:mb-[25px] lg:mb-[30px]">
          <div class="flex items-center justify-between">
            <span class="block font-medium mb-[8px]"> Progress </span>
            <span class="block font-medium mb-[8px]"> 90% </span>
          </div>
          <div
            class="flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]"
          >
            <div
              class="flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md"
              style="width: 90%"
            ></div>
          </div>
        </div>
        <a
          href="javascript:void(0);"
          class="block w-full rounded-md text-center font-medium border border-primary-500 py-[8.5px] px-[15px] text-primary-500 transition-all hover:bg-primary-500 hover:text-white"
        >
          View Details
        </a>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <img
              src="@/assets/images/users/user18.jpg"
              alt="user-image"
              class="w-[65px] h-[65px] rounded-full border-[2px] border-gray-100 dark:border-[#172036]"
            />
            <div class="ltr:ml-[12px] rtl:mr-[12px]">
              <span
                class="text-md inline-block mb-px font-medium text-black dark:text-white"
              >
                Rodriguez Meade
              </span>
              <span class="block"> Team Leader </span>
            </div>
          </div>
          <div class="flex items-center gap-[9px]">
            <button
              type="button"
              class="text-primary-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="View"
            >
              <i class="material-symbols-outlined !text-md"> visibility </i>
            </button>
            <button
              type="button"
              class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Edit"
            >
              <i class="material-symbols-outlined !text-md"> edit </i>
            </button>
            <button
              type="button"
              class="text-danger-500 leading-none custom-tooltip"
              id="customTooltip"
              data-text="Delete"
            >
              <i class="material-symbols-outlined !text-md"> delete </i>
            </button>
          </div>
        </div>
        <div class="text-center mt-[15px]">
          <span
            class="inline-block font-medium bg-purple-100 dark:bg-[#15203c] text-black dark:text-white rounded-full px-[15px] py-[4.5px] mb-[15px]"
          >
            eLearniv - React
          </span>
          <span class="block mb-[8px]"> Team Members </span>
          <div class="flex items-center justify-center">
            <img
              src="@/assets/images/users/user19.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
            <img
              src="@/assets/images/users/user20.jpg"
              alt="user-image"
              class="rounded-full w-[40px] h-[40px] border-[2px] border-gray-100 dark:border-[#172036] -mx-[6px]"
            />
          </div>
        </div>
        <div class="mt-[18px] mb-[20px] md:mb-[25px] lg:mb-[30px]">
          <div class="flex items-center justify-between">
            <span class="block font-medium mb-[8px]"> Progress </span>
            <span class="block font-medium mb-[8px]"> 80% </span>
          </div>
          <div
            class="flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]"
          >
            <div
              class="flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md"
              style="width: 80%"
            ></div>
          </div>
        </div>
        <a
          href="javascript:void(0);"
          class="block w-full rounded-md text-center font-medium border border-primary-500 py-[8.5px] px-[15px] text-primary-500 transition-all hover:bg-primary-500 hover:text-white"
        >
          View Details
        </a>
      </div>
    </div>
  </div>

  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div class="trezo-card-content">
      <Pagination items="8" total="36" class="pt-[0] md:pt-[0]" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Pagination from "@/components/Common/Pagination.vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Teams",
  components: {
    Pagination,
  },
});
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .md\:pt-\[0\] {
    padding-top: 0 !important;
  }
}
.pt-\[0\] {
  padding-top: 0 !important;
}
</style>
